// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Link } from 'gatsby';
import uuid from 'react-uuid';

// Components
import Container from '../../container/container';
import Image from '../../image/image';

// Hooks
import useServicesOptions from '../../../hooks/useServicesOptions';

// Styles
import StackedBoxesStyles from './stackedBoxes.styles';

export default function StackedBoxes({ layout, predefined, isFirstLayout }) {
  const servicesOptions = useServicesOptions();

  let data = layout;

  if (predefined) {
    data =
      predefined === 'services'
        ? servicesOptions?.services
        : servicesOptions?.seoPageServices;
  }

  let bgImg = data?.backgroundImage;
  let heading = data?.heading;
  let boxes = data?.boxes || [];
  const bgColor = data?.backgroundColour || 'white';

  if (predefined === 'services') {
    const services = layout?.services || [];

    if (services.includes('core')) boxes = boxes.concat(data?.coreBoxes);
    if (services.includes('additional'))
      boxes = boxes.concat(data?.additionalBoxes);

    bgImg = layout?.displayBackgroundImage ? bgImg : null;
    heading = layout?.displayHeading ? heading : null;
  }

  return (
    <StackedBoxesStyles bgColor={bgColor}>
      {bgImg && <Image image={bgImg} className="bg" />}

      <Container>
        {heading && isFirstLayout && <h1 className="heading">{heading}</h1>}

        {heading && !isFirstLayout && (
          <h2 className="heading large">{heading}</h2>
        )}

        <div className="boxes">
          {boxes &&
            boxes.map((box) => (
              <div className="box" key={uuid()}>
                <div className="box-inner">
                  {box?.heading && (
                    <h2 className="heading large-mobile">{box?.heading}</h2>
                  )}

                  <span className="text">{box?.text && parse(box?.text)}</span>

                  {box?.buttons && (
                    <div className="btn-group">
                      {box?.buttons.map((button) => (
                        <Link
                          key={button?.button?.title}
                          to={button?.button?.url}
                          className="btn"
                        >
                          {button?.button?.title}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>
      </Container>
    </StackedBoxesStyles>
  );
}

StackedBoxes.propTypes = {
  layout: PropTypes.shape({
    services: PropTypes.arrayOf(PropTypes.string),
    displayHeading: PropTypes.bool,
    displayBackgroundImage: PropTypes.bool,
    heading: PropTypes.string,
    backgroundImage: PropTypes.shape({
      altText: PropTypes.string,
      gatsbyImage: PropTypes.shape({}),
    }),
    backgroundColour: PropTypes.string,
    boxes: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        text: PropTypes.string,
        buttons: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    ),
    coreBoxes: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        text: PropTypes.string,
        buttons: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    ),
    additionalBoxes: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        text: PropTypes.string,
        buttons: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    ),
  }),
  predefined: PropTypes.string,
  isFirstLayout: PropTypes.bool,
};

StackedBoxes.defaultProps = {
  layout: {
    backgroundColour: 'white',
    services: [],
  },
  predefined: null,
  isFirstLayout: false,
};
